import React from "react";
import { connect } from "react-redux";

import { INSPECTION_QUESTIONS } from "./questions";

const formatDateTime = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("pl-PL");
};

const InspectionSummary = ({ inspection }) => {
  if (!inspection?.confirmed_at) return null;

  return (
    <div className="box-6">
      <div className="dashboard">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">
            Podsumowanie kontroli dostawy
          </h2>
        </header>
        <div className="grn-inspection-summary">
          <div className="grn-inspection-summary__meta">
            <p>
              Data i godzina zatwierdzenia:{" "}
              {formatDateTime(inspection.confirmed_at)}
            </p>
            <p>
              Osoba odbierająca i potwierdzająca dostawę:{" "}
              {inspection.confirmed_by?.full_name || "-"}
            </p>
          </div>
          {INSPECTION_QUESTIONS.map((question) => {
            const { key, label } = question;

            return (
              <div className="grn-inspection-summary__item" key={key}>
                <p className="grn-inspection-summary__question">{label}</p>
                <p className="grn-inspection-summary__answer">
                  {inspection[key] ? "TAK" : "NIE"}
                </p>
                {question.correct_answer !== inspection[key] &&
                  inspection[`${key}_note`] && (
                    <p className="grn-inspection-summary__note">
                      Uwaga: {inspection[`${key}_note`]}
                    </p>
                  )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default connect(({ grn }) => ({
  inspection: grn?.data?.grn_inspection,
}))(InspectionSummary);
